import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TermosPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        <section className="bg-white py-24">
          <div className="max-w-4xl mx-auto px-6 lg:px-12">
            <div className="mb-12">
              <Link
                to="/"
                className="inline-flex items-center text-gray-600 hover:text-black transition-colors mb-6 cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                Voltar para home
              </Link>
              <h1 className="text-5xl font-bold text-black mb-4">Termos de Uso</h1>
              <p className="text-gray-600">Última atualização: Janeiro de 2025</p>
            </div>

            <div className="prose prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-black mb-4 mt-12">1. Aceitação dos Termos</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Ao acessar e usar o site da Bravia Group, você concorda em cumprir e estar vinculado a estes Termos de Uso. Se você não concorda com qualquer parte destes termos, não deve usar nosso site.
              </p>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">2. Uso do Site</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Este site é fornecido apenas para fins informativos sobre os serviços e projetos da Bravia Group. Você concorda em usar o site apenas para fins legais e de maneira que não infrinja os direitos de terceiros ou restrinja ou iniba o uso do site por qualquer outra pessoa.
              </p>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">3. Informações sobre Investimentos</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                As informações fornecidas neste site sobre oportunidades de investimento são apenas para fins informativos e não constituem uma oferta de venda ou solicitação de compra de valores mobiliários. Todos os investimentos envolvem riscos, incluindo a possível perda de capital.
              </p>

              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 my-8">
                <p className="text-gray-800 font-semibold mb-2">Aviso Importante:</p>
                <p className="text-gray-700 leading-relaxed">
                  Os retornos estimados apresentados são baseados em análises de mercado e histórico de projetos anteriores. Não há garantia de retorno. Recomendamos fortemente que você consulte um assessor financeiro qualificado antes de tomar qualquer decisão de investimento.
                </p>
              </div>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">4. Propriedade Intelectual</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Todo o conteúdo deste site, incluindo textos, gráficos, logos, imagens e software, é propriedade da Bravia Group ou de seus fornecedores de conteúdo e é protegido por leis de direitos autorais e outras leis de propriedade intelectual.
              </p>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">5. Links para Sites de Terceiros</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Nosso site pode conter links para sites de terceiros. Não somos responsáveis pelo conteúdo ou práticas de privacidade desses sites. O acesso a sites de terceiros é por sua conta e risco.
              </p>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">6. Limitação de Responsabilidade</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                A Bravia Group não será responsável por quaisquer danos diretos, indiretos, incidentais, consequenciais ou punitivos decorrentes do uso ou incapacidade de usar este site ou qualquer informação nele contida.
              </p>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">7. Modificações</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. As alterações entrarão em vigor imediatamente após a publicação no site. Seu uso continuado do site após tais alterações constitui sua aceitação dos novos termos.
              </p>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">8. Lei Aplicável</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Estes Termos de Uso são regidos pelas leis do Estado da Flórida, Estados Unidos, sem considerar conflitos de disposições legais.
              </p>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">9. Contato</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco através do email contato@braviagroup.com ou pelo telefone +1 (813) 555-0100.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
